
import { Component, Prop, Vue } from "vue-property-decorator";
import { QaAnswerBlock, QaListBlock, parseEmphasis } from "@/models/QaAnswer";

// 答案內容渲染：段落、ul/ol 清單、子問答（子問答的 body 交給自己遞迴渲染），/QA 與 /MobileQA 共用。
// 外層樣式（寬度、內距、底線）由使用端加上 class="qa-answer"。
@Component({ name: "QaAnswerContent" })
export default class QaAnswerContent extends Vue {
  @Prop({ required: true }) readonly blocks!: QaAnswerBlock[];

  parseEmphasis = parseEmphasis;

  isList(block: QaAnswerBlock): block is QaListBlock {
    return typeof block !== "string" && "list" in block;
  }
}
